import React, {useState} from 'react';
import {Button, Menu, MenuItem} from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import SwapVertIcon from '@mui/icons-material/SwapVert';
import {SearchSupplierSortType} from "../../../../types/supplier/SearchSupplierSortType";

const SORT_OPTIONS: {value: SearchSupplierSortType, label: string}[] = [
  {value: 'distance', label: 'Distance'},
  {value: 'monthly-rate-low', label: 'Monthly Rate Low'},
  {value: 'monthly-rate-high', label: 'Monthly Rate High'},
  {value: 'daily-rate-low', label: 'Daily Rate Low'},
  {value: 'daily-rate-high', label: 'Daily Rate High'},
];

interface SortMenuButtonProps {
  value: SearchSupplierSortType;
  onChange: (value: SearchSupplierSortType) => void;
}

const SortMenuButton = ({value, onChange}: SortMenuButtonProps) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const current = SORT_OPTIONS.find(o => o.value === value)?.label ?? value;

  return (
    <>
      <Button
        size="small"
        color="inherit"
        startIcon={<SwapVertIcon fontSize="small"/>}
        endIcon={<ArrowDropDownIcon/>}
        onClick={e => setAnchorEl(e.currentTarget)}
        aria-haspopup="menu"
        aria-expanded={Boolean(anchorEl)}
        aria-label={`Sort by ${current}`}
        sx={{flexShrink: 0, color: 'text.secondary', textTransform: 'none', fontWeight: 600}}
      >
        {current}
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}
        transformOrigin={{vertical: 'top', horizontal: 'right'}}
      >
        {SORT_OPTIONS.map(o => (
          <MenuItem key={o.value} selected={o.value === value} onClick={() => { onChange(o.value); setAnchorEl(null); }}>
            {o.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default SortMenuButton;
